<div class="payment-success-container">
  <h2>Pagamento Realizado com Sucesso!</h2>
  <p>
    ID do Pedido: <strong>{{ paymentId }}</strong>
  </p>
  <a routerLink="/">Voltar para a Home</a>
</div>
